import { Button, Dropdown, theme } from '@/components';
import { SortAscendingOutlined } from '@ant-design/icons';
import type { FC } from 'react';

import { useSiderCommentFilterStorage } from '@/features/comment/hooks/local-storage';
import {
  type CommentOrderingType,
  CommentSortTypeLabelModifier,
  commentSortType,
} from '@/features/comment/models/comment';

const orderingOptions = commentSortType.options.map((value) => ({
  key: value,
  label: CommentSortTypeLabelModifier[value],
}));

type Props = {
  commentsOrdering: CommentOrderingType;
  setCommentsOrdering: (ordering: CommentOrderingType) => void;
};

export const CommentSiderListSorter: FC<Props> = ({
  commentsOrdering,
  setCommentsOrdering,
}) => {
  const { token } = theme.useToken();

  const { lastSearched, setSearchHistoryStorage } =
    useSiderCommentFilterStorage();

  return (
    <Dropdown
      menu={{
        items: orderingOptions,
        onClick: (option) => {
          const key = option.key as CommentOrderingType;
          setSearchHistoryStorage({
            ...lastSearched,
            ordering: key,
          });
          setCommentsOrdering(key);
        },
      }}
    >
      <Button type="text">
        <SortAscendingOutlined aria-label="" color={token.colorTextTertiary} />
        {CommentSortTypeLabelModifier[commentsOrdering]}
      </Button>
    </Dropdown>
  );
};
